import Employee from "@/employee/Employee"
import { object, serializable } from "serializr"
import Research from "@/Research"
import Farm from "@/farm/Farm"

export class ResearchItem {
    private farm: Farm
    private employee: Employee

    @serializable(object(Research))
    public readonly research: Research

    @serializable
    private _isEquipped: boolean = false
    @serializable
    private hasBeenEquippedOnce: boolean = false

    constructor(research: Research, employee: Employee, farm: Farm) {
      this.farm = farm
      this.employee = employee
      this.research = research
    }

    load(state: any) {
      this._isEquipped = state._isEquipped
      this.hasBeenEquippedOnce = state.hasBeenEquippedOnce
    }

    toggleEquip() {
      if (this.isEquipped) {
        this.unequip()
      } else {
        this.equip()
      }
    }

    equip() {
      if (!this.hasBeenEquippedOnce) {
        // If we can't pay, do not equip
        if (!this.farm.canPay(this.research.equipCost)) {
          this.employee.chatHistory.addMessage(this.employee.getSpeech("unaffordableEquipment"))
          return
        }

        // Equip
        this.hasBeenEquippedOnce = true
        this.farm.pay(this.research.equipCost)
      }
      this._isEquipped = true
      this.employee.effectManager.addResearch(this.research, this.employee.effectToModsMap)
    }

    unequip() {
      if (!this.research.isUnequippable) return

      this._isEquipped = false
      this.employee.effectManager.removeResearch(this.research, this.employee.effectToModsMap)
    }

    get isEquipped() {
      return this._isEquipped
    }

    get canBeUnequipped() {
      return this.isEquipped && this.research.isUnequippable
    }

    get equipCost() {
      if (this.hasBeenEquippedOnce) return 0
      return this.research.equipCost
    }
}
